import React from 'react';
import ContactFormSA from '../../../components/common/ContactFormSA';

const HeroSection = () => {
  return (
    <section
      data-screen-label="Hero"
      style={{
        background: 'linear-gradient(180deg, #F3F0E7 0%, #EAE4D5 100%)',
        padding: 'clamp(36px, 4vw, 56px) clamp(16px, 4vw, 48px) clamp(40px, 4.5vw, 64px)',
        textAlign: 'left',
      }}
    >
      <div
        className="hero-grid"
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          alignItems: 'start',
        }}
      >
        <div className="hero-copy-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div
            style={{
              display: 'inline-flex',
              alignSelf: 'flex-start',
              alignItems: 'center',
              gap: '8px',
              background: '#FBFAF6',
              border: '1px solid #DCD5C5',
              borderRadius: '999px',
              padding: '6px 14px',
              fontSize: '12px',
              fontWeight: '700',
              letterSpacing: '1.5px',
              color: '#B5652E',
            }}
          >
            INDEPENDENT PRIVATE ADVISORY FIRM
          </div>
          <h1
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: 'clamp(28px, 5vw, 44px)',
              lineHeight: 1.12,
              color: '#26332C',
              margin: 0,
              fontWeight: 800,
              textWrap: 'pretty',
            }}
          >
            Corporate Tax &amp; Audit Advisory for UAE Businesses
          </h1>
          <p style={{ fontSize: '17px', lineHeight: 1.65, margin: 0, maxWidth: '52ch', color: '#39362F' }}>
            From eligibility assessments to return preparation and review, our certified accountants keep your numbers accurate and audit-ready — without the cost of building a finance team in-house.
          </p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <span
              style={{
                background: '#FBFAF6',
                border: '1px solid #DCD5C5',
                borderRadius: '8px',
                padding: '8px 14px',
                fontSize: '13px',
                fontWeight: 600,
                color: '#26332C',
              }}
            >
              IFRS-aligned reporting
            </span>
            <span
              style={{
                background: '#FBFAF6',
                border: '1px solid #DCD5C5',
                borderRadius: '8px',
                padding: '8px 14px',
                fontSize: '13px',
                fontWeight: 600,
                color: '#26332C',
              }}
            >
              One point of contact, always
            </span>
          </div>
        </div>

        <div
          id="consult"
          style={{
            background: '#FBFAF6',
            borderRadius: '16px',
            boxShadow: '0 24px 60px rgba(38,51,44,0.12)',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              background: '#26332C',
              padding: '24px 28px 20px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}
          >
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", color: '#FBFAF6', fontSize: '22px', margin: 0, fontWeight: 800 }}>
              Free Corporate Tax Check
            </h2>
            <p style={{ margin: 0, fontSize: '13.5px', color: '#D8D2C2', lineHeight: 1.5 }}>
              Know exactly where you stand — a certified accountant reviews your books and calls you back within 24 hours. No cost, no obligation.
            </p>
          </div>
          <ContactFormSA isCta={false} />
        </div>

        <div className="info-card-wrapper">
          <div
            style={{
              background: '#FBFAF6',
              border: '1px solid #DCD5C5',
              borderLeft: '3px solid #26332C',
              borderRadius: '10px',
              padding: '16px 20px',
              fontSize: '13.5px',
              lineHeight: 1.6,
              color: '#5C574C',
            }}
          >
            <strong style={{ color: '#26332C' }}>
              Standard Auditing is an independent private tax and audit consulting firm based in Dubai, UAE.
            </strong>{' '}
            We are not a government authority and do not issue government documents. We provide advisory, preparation, and compliance support for corporate tax and audit matters.
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
